import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  amount: number | string
}

const Outstanding = ({ amount }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween" textAlign="left">
        <Text.Normal color="grey000White">
          {i18n.t('time_off.available_tooltip.outstanding')}
        </Text.Normal>
        <Text.Normal color="grey000White">{amount}</Text.Normal>
      </Box>
    </Box>
  )
}

export default Outstanding
